module.exports = __webpack_public_path__ + "static/media/problem_white.40b7745b.svg";